export default __webpack_public_path__ + "static/media/Feelin_ Good.1df57dad.png";